<template>
	<div>
		<section v-if="showTagged">
			<section class="w-100 px-3 py-2">
				<h2>Tagged Groups and Individuals</h2>
			</section>
			<hr class="mb-0" />
			<section
				v-if="groups"
				class="px-1 overflow-auto pt-2"
				style="height: calc(100vh - 267px)"
			>
				<template v-if="!groups.length">
					<div class="configpreviewgraph text-center">
						<img src="../../assets/icons/testconfig/noindividual.svg" alt="" />
						<div
							class="d-flex goToShareLink justify-content-center mt-3 pointer"
							@click="goToSharePage"
						>
							Go To Share Link Page
							<img
								src="../../assets/icons/testconfig/leftArrow.svg"
								alt=""
								class="ml-2"
							/>
						</div>
					</div>
				</template>
				<template v-else>
					<div
						v-for="(group, index) in groups"
						:key="index"
						class="tagged-cards my-2 d-flex align-items-center justify-content-between"
					>
						<div class="d-flex">
							<img
								v-if="group.candidateType == 'I'"
								src="../../assets/projects-icons/individual.svg"
							/>
							<img
								v-else-if="group.candidateType == 'G'"
								src="../../assets/projects-icons/group.svg"
							/>
							<img
								v-else-if="group.candidateType == 'R'"
								src="../../assets/projects-icons/group-rec.svg"
							/>
							<div class="ml-2 mb-1">{{ group.groupName }}</div>
						</div>
						<div class="d-flex">
							<img
								@click="viewGroupInfo(group)"
								class="pointer"
								:class="{ 'mr-3': group.configID }"
								src="../../assets/preview eye.svg"
							/>
							<img
								v-if="group.configID"
								@click="openSideConfig(group.configID)"
								class="pointer"
								src="../../assets/projects-icons/right-arr.svg"
							/>
						</div>
					</div>
				</template>
			</section>
		</section>
		<section v-if="sideConfig">
			<section class="w-100 px-3 pt-2 d-flex">
				<div
					@click="(showTagged = true), (sideConfig = false)"
					class="mr-2 pointer"
				>
					<img src="../../assets/icons/Reports/bckarrow.svg" />
				</div>
				<h2>Configuration</h2>
			</section>
			<hr class="mb-0" />
			<section
				class="px-3 overflow-auto pt-3"
				style="height: calc(100vh - 240px)"
			>
				<div class="screendisplay-content mb-3">
					<div
						class="config-cards mt-0"
						:class="{ 'openconfig-cards': openIndex == 0 }"
					>
						<div
							class="d-flex justify-content-between align-items-center relativeclass mt-0 pointer"
							v-b-toggle.screendisplay
							@click="updateOpenIndex(0)"
						>
							<span class="testconfig-btns mt-0" style="width: 90%">
								Opening Screen Display</span
							>
							<span
								v-if="roles.includes('PUT_CONFIG')"
								@click.stop="openSelectedTab(0)"
								class="mr-3"
							>
								<img
									@click="openModal(0)"
									src="../../assets/pencilicon.svg"
									alt=""
								/>
							</span>
							<span class="when-closed">
								<img src="../../assets/downarrow.svg" alt="" />
							</span>
							<span class="when-open">
								<img src="../../assets/uparrow.svg" alt="" />
							</span>
						</div>
					</div>
					<b-collapse
						id="screendisplay"
						accordion="my-accordion"
						role="tabpanel"
						visible
					>
						<b-card-body>
							<div>
								<div class="ts-sideconfg-heading">Config Name</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.configName }}
								</div>
							</div>
							<hr />
							<div>
								<div class="ts-sideconfg-heading">Test Organiser</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.testOrg }}
								</div>
							</div>
							<hr />
							<div>
								<div class="ts-sideconfg-heading">Test Description</div>
								<div
									class="ts-sideconfg-content"
									v-html-safe="testConfigData.config.testDesc"
								></div>
							</div>
							<hr />

							<div>
								<div class="ts-sideconfg-heading">Test</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.test }}
								</div>
							</div>
						</b-card-body>
					</b-collapse>
				</div>
				<div class="screendisplay-content mb-3">
					<div
						class="config-cards"
						:class="{ 'openconfig-cards': openIndex == 1 }"
					>
						<div
							class="d-flex justify-content-between align-items-center relativeclass pointer"
							v-b-toggle.questnbehaviour
							@click="updateOpenIndex(1)"
						>
							<span class="testconfig-btns" style="width: 90%"
								>Questions Behaviour
							</span>
							<span
								v-if="roles.includes('PUT_CONFIG')"
								@click.stop="openSelectedTab(1)"
								class="mr-3"
							>
								<img
									@click="openModal(1)"
									src="../../assets/pencilicon.svg"
									alt=""
								/>
							</span>
							<span class="when-closed">
								<img src="../../assets/downarrow.svg" alt="" />
							</span>
							<span class="when-open">
								<img src="../../assets/uparrow.svg" alt="" />
							</span>
						</div>
					</div>
					<b-collapse
						id="questnbehaviour"
						accordion="my-accordion"
						role="tabpanel"
					>
						<b-card-body>
							<div>
								<div class="ts-sideconfg-heading">Test Duration (Minutes)</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.testDuration }}
								</div>
							</div>
							<hr />

							<div>
								<div class="ts-sideconfg-heading">Start Test Date & Time</div>
								<div class="ts-sideconfg-content">
									{{ getITCDateTime(testConfigData.config.openTestdt) }}
								</div>
							</div>
							<hr />
							<div>
								<div class="ts-sideconfg-heading">End Test Date & Time</div>
								<div class="ts-sideconfg-content">
									{{ getITCDateTime(testConfigData.config.closeTestdt) }}
								</div>
							</div>
							<hr />

							<div v-if="$route.name != 'MyProjects'">
								<div class="ts-sideconfg-heading">
									Number Of Questions Per Screen
								</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.quesPerScreen }}
								</div>
							</div>
							<hr />
							<div v-if="$route.name != 'myprojects'">
								<div class="ts-sideconfg-heading">
									Randomly Shuffle Questions
								</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.shuffle"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr v-if="$route.name != 'myprojects'" />
							<div>
								<div class="ts-sideconfg-heading">
									Maximum number Of Attempts
								</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.maxnoattempts }}
								</div>
							</div>
							<hr v-if="$route.name != 'myprojects'" />
							<div v-if="$route.name != 'myprojects'">
								<div class="ts-sideconfg-heading">Buffer Time (Minutes)</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.buffertime }}
								</div>
							</div>
							<hr v-if="testConfigData.config.maxnoattempts > 1" />
							<div v-if="testConfigData.config.maxnoattempts > 1">
								<div class="ts-sideconfg-heading">
									Time between attempts ({{ testConfigData.config.timebnsel }})
								</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.timebnvalue }}
								</div>
							</div>
							<hr />
							<div v-if="$route.name != 'myprojects'">
								<div class="ts-sideconfg-heading">
									Display Mandatory Questions Icon
								</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.dispReqStatus"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr v-if="$route.name != 'myprojects'" />
							<div>
								<div class="ts-sideconfg-heading">
									Display Mandatory Questions First
								</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.displayReqFirst"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr />
							<div v-if="$route.name != 'myprojects'">
								<div class="ts-sideconfg-heading">
									Display Marks For Every Question
								</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.dispMarks"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr v-if="$route.name != 'myprojects'" />

							<div v-if="$route.name != 'myprojects'">
								<div class="ts-sideconfg-heading">Specify Negative Marks</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.negativeMarkValue }}
								</div>
							</div>
						</b-card-body>
					</b-collapse>
				</div>
				<div class="screendisplay-content mb-3">
					<div
						class="config-cards"
						:class="{ 'openconfig-cards': openIndex == 2 }"
					>
						<div
							class="d-flex justify-content-between align-items-center relativeclass pointer"
							v-b-toggle.systemsetup
							@click="updateOpenIndex(2)"
						>
							<span class="testconfig-btns" style="width: 90%"
								>System Setup</span
							>
							<span
								v-if="roles.includes('PUT_CONFIG')"
								@click.stop="openSelectedTab(2)"
								class="mr-3"
							>
								<img
									@click="openModal(2)"
									src="../../assets/pencilicon.svg"
									alt=""
								/>
							</span>
							<span class="when-closed">
								<img src="../../assets/downarrow.svg" alt="" />
							</span>
							<span class="when-open">
								<img src="../../assets/uparrow.svg" alt="" />
							</span>
						</div>
					</div>
					<b-collapse id="systemsetup" accordion="my-accordion" role="tabpanel">
						<b-card-body>
							<template v-if="testConfigData.config.enableProctoring">
								<div>
									<div class="ts-sideconfg-heading">
										Set Image Capture Timing-Slot (second)
									</div>
									<div class="ts-sideconfg-content">
										{{ testConfigData.config.screenCapture }}
									</div>
								</div>
								<hr />
							</template>

							<template v-if="testConfigData.config.communicationTest">
								<div>
									<div class="ts-sideconfg-heading">
										Communication Test Duration (Seconds)
									</div>
									<div class="ts-communisideconfg-content">
										{{ testConfigData.config.communicationTestDuration }}
									</div>
								</div>
								<hr />
							</template>
							<div>
								<div class="ts-sideconfg-heading">Communication Test</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.communicationTest"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr />

							<div>
								<div class="ts-sideconfg-heading">Enable Video Proctoring</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.enableProctoring"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr />
							<template v-if="testConfigData.config.typingTest">
								<div>
									<div class="ts-sideconfg-heading">Typing Duration</div>
									<div class="ts-sideconfg-content">
										{{ testConfigData.config.typingDuration }}
									</div>
								</div>
								<hr />
							</template>

							<div>
								<div class="ts-sideconfg-heading">Typing Test</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.typingTest"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr />

							<div>
								<div class="ts-sideconfg-heading">Enable Video Recording</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.enableCamera"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr />
							<div>
								<div class="ts-sideconfg-heading">
									Include Time Sensitivity Notifications
								</div>
								<div
									v-if="testConfigData.config.includeTimeNotifics"
									class="ts-sideconfg-content"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr />
							<div>
								<div class="ts-sideconfg-heading">Enable Internet Check</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.internetCheck"
								>
									Yes
								</div>
								<div class="ts-sideconfg-content" v-else>No</div>
							</div>
							<hr />

							<div>
								<div class="ts-sideconfg-heading">Allow Candidate Feedback</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.allowCandidateRemarks"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr />
							<div>
								<div class="ts-sideconfg-heading">Allow Agent</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.allowAgent"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr />
							<div>
								<div class="ts-sideconfg-heading">Passing Percentage</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.passingPercentage }}
								</div>
							</div>
							<hr />
							<div>
								<div class="ts-sideconfg-heading">Allow Extension</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.allowExtension"
								>
									Yes
								</div>
								<div class="ts-sideconfg-content" v-else>No</div>
							</div>
							<hr />
							<div>
								<div class="ts-sideconfg-heading">Allow Location</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.allowLocation"
								>
									Yes
								</div>
								<div class="ts-sideconfg-content" v-else>No</div>
							</div>
							<hr />
							<div>
								<div class="ts-sideconfg-heading">
									Allow Image and ID capture
								</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.allowImageAndIdCapture"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr v-if="$route.name != 'myprojects'" />
							<div v-if="$route.name != 'myprojects'">
								<div class="ts-sideconfg-heading">Instant Test Result</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.instantemail"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
							<hr v-if="$route.name != 'myprojects'" />
							<div v-if="$route.name != 'myprojects'">
								<div class="ts-sideconfg-heading">Enable ScreenShare</div>
								<div
									class="ts-sideconfg-content"
									v-if="testConfigData.config.enableScreenShare"
								>
									Yes
								</div>
								<div v-else class="ts-sideconfg-content">No</div>
							</div>
						</b-card-body>
					</b-collapse>
				</div>
				<div class="screendisplay-content mb-3">
					<div
						class="config-cards"
						:class="{ 'openconfig-cards': openIndex == 3 }"
					>
						<div
							class="d-flex justify-content-between align-items-center relativeclass pointer"
							v-b-toggle.dondonts
							@click="updateOpenIndex(3)"
						>
							<span class="testconfig-btns" style="width: 90%"
								>Do’s and Dont’s</span
							>
							<span
								v-if="roles.includes('PUT_CONFIG')"
								@click="openSelectedTab(3)"
								class="mr-3"
							>
								<img
									@click="openModal(3)"
									src="../../assets/pencilicon.svg"
									alt=""
								/>
							</span>
							<span class="when-closed">
								<img src="../../assets/downarrow.svg" alt="" />
							</span>
							<span class="when-open">
								<img src="../../assets/uparrow.svg" alt="" />
							</span>
						</div>
					</div>
					<b-collapse id="dondonts" accordion="my-accordion" role="tabpanel">
						<b-card-body>
							<div>
								<div class="ts-sideconfg-heading">Do's and Dont's</div>
								<div
									v-for="(i, index) in testConfigData.config.dosAndDonts"
									:key="i.value"
									class="ts-sideconfg-content"
								>
									<span class="mt-3">{{ index + 1 }}</span
									>. {{ i.value }}
								</div>
							</div>
						</b-card-body>
					</b-collapse>
				</div>
			</section>
		</section>
		<b-modal
			id="viewgroup-1"
			centered
			hide-footer
			hide-header
			class="shareview-modal"
			:no-close-on-backdrop="true"
		>
			<div class="modalhead-sm ml-3 mt-1 pt-3">
				<span>View </span>
				<span
					v-if="
						selectedGroup.candidateType == 'G' ||
							selectedGroup.candidateType == 'R'
					"
					>Group</span
				>
				<span v-else> Individual </span>
			</div>
			<hr />
			<div @click="$bvModal.hide('viewgroup-1')" class="xMark-pos">
				<img src="../../assets/blue-xmark.svg" alt="" />
			</div>
			<div class="stc-view-grp-overflow">
				<!-- <div
          class="groupheading text-truncate ml-3 mt-1"
          v-if="
            selectedGroup.candidateType == 'G' ||
            selectedGroup.candidateType == 'R'
          "
        >
          {{ selectedGroup.groupName }}
        </div> -->
				<div
					v-if="selectedGroup.candidateType == 'I'"
					class="groupheading text-truncate d-flex ml-3 mt-1 mb-3"
				>
					<img
						src="../../assets/projects-icons/individual.svg"
						alt=""
						class="mr-2"
					/>

					{{ selectedGroup.groupName }}
				</div>
				<div
					class="sm-cards"
					v-if="
						selectedGroup.candidateType == 'G' ||
							selectedGroup.candidateType == 'R'
					"
				>
					<div
						class="d-flex justify-content-between shareview-details pl-2 pr-2 pb-3 pt-3"
					>
						<div class="d-flex flex-column ml-2">
							<span class="sm-card-head"
								>Group Candidates: {{ selectedGroup.candidates.length }}</span
							>
						</div>
						<div class="d-flex flex-column mr-2">
							<span class="sm-date">Created On:</span>
							<span class="sm-date"
								>({{ selectedGroup.createdAt | datefilter }})</span
							>
						</div>
					</div>
					<div class="p-3 stc-share-viewgroup-container mr-2">
						<div
							class="mb-3"
							v-for="candidate in selectedGroup.candidates"
							:key="candidate"
						>
							<div class="d-flex justify-content-between">
								<div class="d-flex justify-content-between">
									<span
										><img
											src="../../assets/projects-icons/individual.svg"
											alt=""
											class="mr-2"
									/></span>
									<div class="shareview-details-email mt-1">
										{{ candidate }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="sm-cards">
					<label class="sm-card-head ml-3 my-3">Configuration Name</label>
					<div
						class="shareview-details d-flex justify-content-between p-3 mb-3"
					>
						<div
							class="shareview-details-bold mt-0"
							v-if="selectedGroup['configID'] == undefined"
						>
							--
						</div>
						<div class="sm-card-head mt-0" v-else>
							{{ selectedGroup.configName }}
						</div>
						<div
							class="deliveredtext mt-0"
							v-if="selectedGroup['configID'] == undefined"
						>
							Not Configured
						</div>

						<span v-else-if="selectedGroup.open == 'False'" class="expiredClass"
							>Expired</span
						>
						<div
							class="d-flex align-items-center justify-content-center active-bubble"
							v-else-if="selectedGroup.open == 'True'"
						>
							Active
						</div>
						<span
							v-else
							class="active-bubble d-flex align-items-center justify-content-center"
							>Active</span
						>
					</div>
					<label class="sm-card-head ml-3 mb-3">Test Link</label>
					<div
						class="shareview-details d-flex justify-content-between align-items-center p-3 mb-3"
					>
						<div
							class="shareview-details-bold"
							v-if="selectedGroup['shareLink'] == undefined"
						>
							--
						</div>
						<div class="sm-card-head sharelink-break" v-else>
							{{ selectedGroup.shareLink }}
						</div>
						<div
							class="deliveredtext"
							v-if="selectedGroup['shareLink'] == undefined"
						>
							No Link Generated
						</div>
						<span
							v-else
							class="active-bubble d-flex align-items-center justify-content-center"
							>Active</span
						>
					</div>
				</div>
				<div class="sm-cards p-3">
					<div class="d-flex justify-content-between align-items-center mb-1">
						<div class="sm-card-head">
							<img src="../../assets/greenEvaluator.svg" alt="" />
							Evaluators
						</div>
						<div class="sm-card-head pr-2">
							Total Evaluators:
							{{ selectedGroup.evaluator.length }}
						</div>
					</div>
					<!-- <div class="stc-model-eval-overflow mr-2">
            <div
              class="d-flex align-items-center ml-1 mt-3"
              style="width: 90%"
              v-for="(evaluator, ind) in selectedGroup.evaluator"
              :key="ind"
            >
              <span
                ><img
                  src="../../assets/projects-icons/individual.svg"
                  alt=""
                  class="mr-2"
              /></span>
              <div class="shareview-details-bold text-truncate">
                {{ evaluator.name }}
              </div>
            </div>
          </div> -->
				</div>
			</div>
			<div class="d-flex justify-content-end grp-modal-foot">
				<div class="okay-btn">
					<b-button @click="$bvModal.hide('viewgroup-1')"> Okay </b-button>
				</div>
			</div>
		</b-modal>
		<b-modal
			id="modal-config"
			v-model="showConfigModal"
			class="testconfigmodal"
			centered
			hide-footer
			hide-header
			size="xl"
			no-close-on-backdrop
		>
			<div class="d-flex tc-modal-body">
				<div class="cs-left-modal-back"></div>
				<div class="body-div-right-tc">
					<div class="p-3 mt-2 conf-form-head">
						<div class="d-flex justify-content-between align-items-center">
							<div class="d-flex px-2">
								<div class="mr-3 pointer" @click="closeModal">
									<img src="../../assets/projects-icons/modal-backarrow.svg" />
								</div>
								<div class="modal-heading-form">Edit Configuration</div>
							</div>
							<div
								@click="closeModal"
								class="xmark-modal-pos-tc rotate-on-hover pointer"
							>
								<img src="../../assets/blue-xmark.svg" alt="" />
							</div>
						</div>
					</div>
					<div class="pan-log-tabs-tc">
						<b-tabs v-model="tabIndex" content-class="mt-3">
							<b-tab active>
								<template #title>
									Opening Screen Display

									<img
										style="position: absolute; top: 15px"
										v-b-popover.hover.top.v-danger="{
											content: 'Please fill all the details',
										}"
										v-if="
											dirtyCheckDescQuestion ||
												$v.testConfigData.config.testOrg.$error ||
												$v.testConfigData.config.testDesc.$error ||
												$v.testConfigData.configName.$error ||
												testoptError
										"
										src="../../assets/projects-icons/big-warning-red.svg"
										alt=""
									/>
									<div v-if="tabIndex == 0" class="tc-tab-sel"></div>
								</template>
								<div class="pr-2 configcontent-tabs-content px-5">
									<b-row class="pb-1">
										<b-col>
											<div class="tc-form-fields mt-3 position-relative">
												<label class="tc-form-labels"
													>Configuration Name<span class="asterik"
														>*</span
													></label
												>
												<b-form-input
													class="mt-1"
													type="text"
													placeholder="Enter Here"
													v-model.trim="$v.testConfigData.configName.$model"
													:class="{
														error: $v.testConfigData.configName.$error,
													}"
												></b-form-input>
												<div
													style="position: absolute; top: 67px; left: 3px"
													v-if="
														$v.testConfigData.configName.$dirty &&
															!$v.testConfigData.configName.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Required',
													}"
													variant="primary"
													class="error-txt-tc"
												>
													Required
												</div>
												<div
													style="position: absolute; top: 67px; left: 3px"
													v-if="
														!$v.testConfigData.configName.maxLength &&
															$v.testConfigData.configName.required
													"
													variant="primary"
													class="error-txt-tc"
												>
													Should not exceed 128 characters
												</div>
											</div>
										</b-col>
										<b-col>
											<div class="tc-form-fields mt-3 relativeclass">
												<label class="tc-form-labels"
													>Test Organiser<span class="asterik">*</span></label
												>
												<b-form-input
													class="mt-1"
													id="input-1"
													type="text"
													placeholder="Enter Here"
													v-model.trim="$v.testConfigData.config.testOrg.$model"
													:class="{
														error: $v.testConfigData.config.testOrg.$error,
													}"
												></b-form-input>
												<div
													style="position: absolute; top: 66px; left: 3px"
													v-if="
														$v.testConfigData.config.testOrg.$dirty &&
															!$v.testConfigData.config.testOrg.required
													"
													class="error-txt-tc"
												>
													Required
												</div>
												<div
													style="position: absolute; top: 66px; right: 3px"
													v-if="
														!$v.testConfigData.config.testOrg.maxLength &&
															$v.testConfigData.config.testOrg.required
													"
													class="error-txt-tc"
												>
													Should not exceed 120 characters
												</div>
											</div>
										</b-col>
										<b-col>
											<div class="mt-3 tc-form-fields">
												<label class="tc-form-labels"
													>Test Type<span class="asterik">*</span></label
												>
												<div class="mt-1 config-select">
													<SingleSelect
														:optionsArray="testoptions"
														v-model="testoption"
													/>
												</div>
												<div
													style="position: absolute; top: 83px; left: 19px"
													v-if="
														testoptError && testConfigData.config.test == ''
													"
													class="error-txt-tc"
													variant="primary"
												>
													Required
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<div class="topDiv mt-4 relativeclass">
												<label class="tc-form-labels"
													>Test Description<span class="asterik">*</span></label
												>
												<div class="conf-quill">
													<QuillEditor
														:addquesProp="addques1"
														v-model="$v.testConfigData.config.testDesc.$model"
														@validationVal="validateText"
														@questionText="updateQuestionContent"
														@addquesBack="changedaddQues"
													>
													</QuillEditor>
												</div>
												<div
													style="position: absolute; top: 5px; right: 12px"
													v-if="
														dirtyCheckDescQuestion &&
															$v.testConfigData.config.testDesc.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Required',
													}"
													variant="primary"
												></div>
												<div
													style="position: absolute; top: 5px; right: 12px"
													v-if="
														!$v.testConfigData.config.testDesc.maxLength &&
															!dirtyCheckDescQuestion
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Should not exceed 1024 characters',
													}"
													variant="primary"
												></div>
												<div
													style="position: absolute; top: 5px; right: 12px"
													v-if="
														dirtyCheckDescQuestion &&
															!$v.testConfigData.config.testDesc.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Required',
													}"
													variant="primary"
												></div>
											</div>
										</b-col>
									</b-row>
								</div>
								<div class="d-flex tc-btnsDiv justify-content-end p-3">
									<!-- <div class="add-btn-tc">
                    <b-button
                      class="h-32 w-87 ml-2"
                      v-if="configType == 'view'"
                      @click="enableEditing"
                    >
                      <span class="add-btn-tc-txt"> Edit</span>
                    </b-button>
                  </div> -->
									<div class="cancelpan-btn">
										<b-button @click="closeModal" class="h-32 w-87 ml-2"
											>Cancel</b-button
										>
									</div>
									<div class="add-btn-tc">
										<b-button
											@click="checkCondition(true)"
											class="h-32 w-87 ml-4"
											><span class="add-btn-tc-txt">Next</span></b-button
										>
									</div>
								</div>
							</b-tab>

							<b-tab>
								<template #title>
									Question Behaviour
									<img
										style="position: absolute; top: 15px"
										v-b-popover.hover.top.v-danger="{
											content: 'Please fill all the details',
										}"
										v-if="
											$v.testConfigData.config.passingPercentage.$error ||
												(($v.testConfigData.config.negativeMarkValue.$error ||
													$v.testConfigData.config.quesPerScreen.$error ||
													$v.testConfigData.config.buffertime.$error) &&
													$route.name != 'myprojects') ||
												$v.testConfigData.config.buffertime.$error ||
												$v.testConfigData.config.timebnsel.$error ||
												$v.testConfigData.config.timebnvalue.$error ||
												$v.testConfigData.config.maxnoattempts.$error ||
												$v.testConfigData.config.testDuration.$error ||
												!$v.testConfigData.config.testDuration.between ||
												$v.testConfigData.config.openTestdt.$error ||
												(!$v.testConfigData.config.closeTestdt.isDateValid &&
													testConfigData.config.closeTestdt != null) ||
												$v.testConfigData.config.closeTestdt.$error
										"
										src="../../assets/projects-icons/big-warning-red.svg"
										alt=""
									/>
									<div v-if="tabIndex == 1" class="tc-tab-sel"></div>
								</template>
								<div class="pr-2 configcontent-tabs-content px-5">
									<b-row>
										<b-col>
											<div
												class="w-100 tc-form-fields topDiv mt-3 relativeclass"
											>
												<label class="tc-form-labels"
													>Start Test Date & Time
													<span class="asterik">*</span></label
												>
												<div class="position-relative">
													<datetime
														placeholder="Select Start date & time"
														ref="startDate"
														id="input-1"
														class="startdateconfig-tc w-100"
														type="datetime"
														:min-datetime="startdatetime"
														use12-hour
														v-model="testConfigData.config.openTestdt"
														:class="{
															error: $v.testConfigData.config.openTestdt.$error,
														}"
													></datetime>
												</div>
												<img
													class="calender-image-tc pointer"
													@click="openDate('startDate')"
													src="../../assets/projects-icons/calendar-new.svg"
													alt=""
												/>
											</div>
											<div
												style="position: absolute; top: 86px; left: 22px"
												v-if="
													$v.testConfigData.config.openTestdt.$dirty &&
														!$v.testConfigData.config.openTestdt.required
												"
												class="error-txt-tc"
												variant="primary"
											>
												Required
											</div>
										</b-col>
										<b-col>
											<div
												class="w-100 tc-form-fields topDiv mt-3 relativeclass"
											>
												<label class="tc-form-labels"
													>End Test Date & Time<span class="asterik">*</span>
												</label>
												<div class="datepicker-tc position-relative">
													<datetime
														placeholder="Select Start date & time"
														ref="endDate"
														id="input-1"
														class="startdateconfig-tc w-100"
														type="datetime"
														:min-datetime="startdatetime"
														use12-hour
														v-model="testConfigData.config.closeTestdt"
														:class="{
															error:
																$v.testConfigData.config.closeTestdt.$error,
														}"
													></datetime>
												</div>
												<img
													class="calender-image-tc pointer"
													@click="openDate('startDate')"
													src="../../assets/projects-icons/calendar-new.svg"
													alt=""
												/>
											</div>
											<div
												style="position: absolute; top: 86px; left: 22px"
												v-if="
													$v.testConfigData.config.closeTestdt.$dirty &&
														!$v.testConfigData.config.closeTestdt.required
												"
												class="error-txt-tc"
												variant="primary"
											>
												Required
											</div>
											<div
												class="testtime-warning-box p-1 mt-1"
												style="margin-top: 10px; padding: 8px"
												v-if="
													!$v.testConfigData.config.closeTestdt.isDateValid &&
														testConfigData.config.closeTestdt != null
												"
											>
												<img src="../../assets/testtimewarning.svg" alt="" />
												End date/time cannot be earlier than the current
												date/time.
											</div>
										</b-col>
										<b-col>
											<div class="tc-form-fields mt-3 relativeclass">
												<label class="tc-form-labels"
													>Test Duration(Minutes)<span class="asterik"
														>*</span
													></label
												>
												<b-form-input
													id="input-1"
													placeholder="Enter Duration in Minutes"
													type="text"
													v-model="$v.testConfigData.config.testDuration.$model"
													@keypress="validateInput($event)"
													:class="{
														error:
															$v.testConfigData.config.testDuration.$error ||
															!$v.testConfigData.config.testDuration.between,
													}"
												></b-form-input>
												<div
													style="position: absolute; top: 67px; left: 6px"
													v-if="
														$v.testConfigData.config.testDuration.$dirty &&
															!$v.testConfigData.config.testDuration.required
													"
													class="error-txt-tc"
													variant="primary"
												>
													Required
												</div>
												<div
													style="position: absolute; top: 67px; left: 6px"
													v-else-if="
														!$v.testConfigData.config.testDuration.between &&
															$v.testConfigData.config.testDuration.required &&
															$v.testConfigData.config.testDuration.numeric
													"
													class="error-txt-tc"
													variant="primary"
												>
													{{
														$route.name === "myprojects"
															? "Should be between 5 to 1440"
															: "Should be between 5 to 360"
													}}
												</div>
												<div
													style="position: absolute; top: 67px; left: 6px"
													v-else-if="
														!$v.testConfigData.config.testDuration.numeric &&
															$v.testConfigData.config.testDuration.required
													"
													class="error-txt-tc"
													variant="primary"
												>
													Enter a valid value
												</div>
												<!-- <div
                          class="testtime-warning-box p-1 mt-1"
                          style="margin-top: 10px; padding: 8px"
                          v-else-if="
                            timeDiffMinutes &&
                            !$v.testConfigData.config.testDuration.invalid
                          "
                        >
                          <img src="../../assets/testtimewarning.svg" alt="" />
                          The difference between end time and start time cannot
                          be less than the test duration.
                        </div> -->
											</div>
										</b-col>
									</b-row>
									<b-row class="mt-2">
										<b-col cols="4">
											<div class="tc-form-fields mt-3 relativeclass">
												<label class="tc-form-labels"
													>Passing Percentage<span class="asterik"
														>*</span
													></label
												>
												<b-form-input
													id="input-1"
													type="text"
													class="mt-1"
													placeholder="Enter Here"
													v-model.trim="
														$v.testConfigData.config.passingPercentage.$model
													"
													@keypress="validateInput($event)"
													:class="{
														error:
															$v.testConfigData.config.passingPercentage.$error,
													}"
												></b-form-input>
												<div
													style="position: absolute; top: 67px; left: 8px"
													v-if="
														$v.testConfigData.config.passingPercentage.$dirty &&
															!$v.testConfigData.config.passingPercentage
																.required
													"
													class="error-txt-tc"
												>
													Required
												</div>
												<div
													style="position: absolute; top: 67px; left: 8px"
													v-else-if="
														!$v.testConfigData.config.passingPercentage
															.numeric &&
															$v.testConfigData.config.passingPercentage
																.required
													"
													class="error-txt-tc"
													variant="primary"
												>
													Not valid number
												</div>
												<div
													style="position: absolute; top: 67px; left: 8px"
													v-else-if="
														!$v.testConfigData.config.passingPercentage
															.between &&
															$v.testConfigData.config.passingPercentage
																.required
													"
													class="error-txt-tc"
													variant="primary"
												>
													Should be between 1 to 100
												</div>
											</div>
										</b-col>
										<b-col cols="4" v-if="$route.name != 'myprojects'">
											<div class="tc-form-fields mt-3 position-relative">
												<label class="tc-form-labels"
													>Number of Questions Per Screen
													<span class="asterik">*</span></label
												>
												<b-form-input
													type="text"
													placeholder="Enter Here"
													class="mt-1"
													v-model.trim="
														$v.testConfigData.config.quesPerScreen.$model
													"
													@keypress="validateInput($event)"
													:class="{
														error:
															$v.testConfigData.config.quesPerScreen.$error,
													}"
												></b-form-input>
												<div
													style="position: absolute; top: 67px; left: 8px"
													v-if="
														$v.testConfigData.config.quesPerScreen.$dirty &&
															!$v.testConfigData.config.quesPerScreen
																.required &&
															$route.name != 'myprojects'
													"
													class="error-txt-tc"
												>
													Required
												</div>
												<div
													style="position: absolute; top: 67px; left: 8px"
													v-if="
														!$v.testConfigData.config.quesPerScreen.between &&
															$v.testConfigData.config.quesPerScreen.numeric &&
															$route.name != 'myprojects'
													"
													class="error-txt-tc"
												>
													Should be between 1 to 10
												</div>
											</div>
										</b-col>
										<b-col cols="4" v-if="$route.name != 'myprojects'">
											<div class="tc-form-fields mt-3 relativeclass">
												<label class="tc-form-labels"
													>Specify Negative Marks
													<span class="asterik">*</span></label
												>
												<b-form-input
													id="input-1"
													type="text"
													class="mt-1"
													placeholder="Enter Here"
													v-model.trim="
														$v.testConfigData.config.negativeMarkValue.$model
													"
													@keypress="validateInput($event)"
													:class="{
														error:
															$v.testConfigData.config.negativeMarkValue
																.$error && $route.name != 'myprojects',
													}"
												></b-form-input>
												<div
													style="position: absolute; top: 67px; left: 8px"
													v-if="
														$v.testConfigData.config.negativeMarkValue.$dirty &&
															!$v.testConfigData.config.negativeMarkValue
																.required &&
															$route.name != 'myprojects'
													"
													class="error-txt-tc"
												>
													Required
												</div>
												<div
													style="position: absolute; top: 67px; left: 8px"
													v-if="
														!$v.testConfigData.config.negativeMarkValue
															.numeric &&
															$v.testConfigData.config.negativeMarkValue
																.required &&
															$route.name != 'myprojects'
													"
													class="error-txt-tc"
												>
													Not valid number
												</div>
												<div
													style="position: absolute; top: 67px; left: 8px"
													v-if="
														!$v.testConfigData.config.negativeMarkValue
															.between &&
															$v.testConfigData.config.negativeMarkValue
																.numeric &&
															$route.name != 'myprojects'
													"
													class="error-txt-tc"
												>
													Should be between 0 to 30
												</div>
											</div>
										</b-col>
										<b-col cols="4">
											<div class="tc-form-fields mt-3 position-relative">
												<label class="tc-form-labels"
													>Maximum Number of Attempts
													<span class="asterik">*</span></label
												>
												<b-form-input
													type="text"
													placeholder="Enter Here"
													v-model.trim="
														$v.testConfigData.config.maxnoattempts.$model
													"
													:class="{
														error:
															$v.testConfigData.config.maxnoattempts.$error,
													}"
													@keypress="validateInput($event)"
													@keyup="checkMaxAttempts"
												></b-form-input>
												<b-popover
													target="attempt"
													triggers="hover"
													placement="bottom"
													customClass="attempt-warning-box"
												>
													<img
														src="../../assets/projects-icons/attempt-warning.svg"
														alt=""
													/>
													As the start and end time & date duration is only
													applicable to a single attempt, you cannot select more
													than one maximum number of attempts.
												</b-popover>
												<div
													style="position: absolute; top: 63px; left: 9px"
													v-if="
														$v.testConfigData.config.maxnoattempts.$dirty &&
															!$v.testConfigData.config.maxnoattempts.required
													"
													class="error-txt-tc"
												>
													Required
												</div>
												<div
													style="position: absolute; top: 63px; left: 9px"
													v-if="
														!$v.testConfigData.config.maxnoattempts.numeric &&
															$v.testConfigData.config.maxnoattempts.required
													"
													class="error-txt-tc"
												>
													Not valid number
												</div>
												<div
													style="position: absolute; top: 63px; left: 9px"
													v-if="
														!$v.testConfigData.config.maxnoattempts.between &&
															$v.testConfigData.config.maxnoattempts.numeric
													"
													class="error-txt-tc"
												>
													Should be between 1 to 10
												</div>
											</div>
										</b-col>
										<b-col cols="4"> </b-col>
									</b-row>

									<b-row class="mt-2">
										<b-col cols="8">
											<label class="tc-form-labels mt-3" style="left: 0">
												Time Between Attempts
												<span class="asterik">*</span></label
											>
										</b-col>
										<b-col cols="4">
											<label
												v-if="testConfigData.config.maxnoattempts > 1"
												class="tc-form-labels mt-3"
												style="left: 0"
											>
												Priority Attempt <span class="asterik">*</span></label
											>
										</b-col>
									</b-row>
									<b-row>
										<b-col cols="4">
											<div class="position-relative mt-2">
												<div
													class="time-div-tc d-flex justify-content-between global-disabledField"
													:class="{
														error: $v.testConfigData.config.timebnsel.$error,
													}"
													:style="
														testConfigData.config.maxnoattempts > 1
															? 'background: none; '
															: 'background: rgba(140, 140, 140, 0.15);color:#667085'
													"
												>
													<span>{{
														testConfigData.config.timebnsel == "hrs"
															? "Hours"
															: testConfigData.config.timebnsel == "mins"
															? "Minutes"
															: testConfigData.config.timebnsel == "days"
															? "Days"
															: "Select"
													}}</span>

													<div>
														<img
															v-if="!timeattempts"
															src="../../assets/projects-icons/downarrow.svg"
															:class="{
																pointer:
																	testConfigData.config.maxnoattempts > 1,
															}"
															alt=""
														/>
														<img
															v-else
															src="../../assets/projects-icons/uparrow.svg"
															:class="{
																pointer:
																	testConfigData.config.maxnoattempts > 1,
															}"
															alt=""
														/>
													</div>
												</div>
												<div
													ref="timelist"
													class="time-div-tc-dpd acs-landingpage-dropdown pointer mt-1"
													v-if="timeattempts"
												>
													<b-form-group>
														<div
															class="w-100 time-div-tc-dpd d-flex flex-column"
														>
															<div
																class="pointer p-2"
																v-for="option in filteredTimeOptions"
																:key="option.value"
																:value="option.value"
																@change="closeTime"
															>
																{{ option.text }}
															</div>
														</div>

														<b-form-radio-group
															@change="closeTime"
															class="w-100"
															id="btn-radios-3"
															v-model="
																$v.testConfigData.config.timebnsel.$model
															"
															:options="filteredTimeOptions"
															name="radio-btn-stacked"
															buttons
															stacked
														></b-form-radio-group>
													</b-form-group>
												</div>
												<div
													style="position: absolute; top: 40px; left: 7px"
													v-if="
														$v.testConfigData.config.timebnsel.$dirty &&
															!$v.testConfigData.config.timebnsel.required
													"
													class="error-txt-tc"
												>
													Required
												</div>
											</div>
										</b-col>
										<b-col cols="4">
											<div class="tc-form-fields mt-2 relativeclass pb-2">
												<b-form-input
													id="input-1"
													type="text"
													:placeholder="
														`${
															testConfigData.config.timebnsel == 'hrs'
																? 'Enter in Hours'
																: testConfigData.config.timebnsel == 'mins'
																? 'Enter in Minutes'
																: testConfigData.config.timebnsel == 'days'
																? 'Enter in Days'
																: 'Enter Time'
														}`
													"
													v-model="$v.testConfigData.config.timebnvalue.$model"
													@keypress="validateInput($event)"
													:class="{
														error:
															($v.testConfigData.config.timebnvalue.$error ||
																testConfigData.config.timebnvalue == '0' ||
																!validateTime ||
																!validTimeBetAttempts) &&
															$v.testConfigData.config.timebnvalue.$dirty,
														inputField:
															testConfigData.config.maxnoattempts > 1 &&
															testConfigData.config.timebnsel !== '',
														testconfiginputField:
															testConfigData.config.maxnoattempts < 2 ||
															testConfigData.config.timebnsel === '',
													}"
													:disabled="
														testConfigData.config.maxnoattempts < 2 ||
															testConfigData.config.timebnsel === ''
													"
												></b-form-input>
												<div
													style="position: absolute; top: 40px; left: 9px"
													v-if="
														$v.testConfigData.config.timebnvalue.$dirty &&
															!$v.testConfigData.config.timebnvalue.required
													"
													class="error-txt-tc"
												>
													Required
												</div>
												<div
													style="position: absolute; top: 40px; left: 9px"
													v-if="
														testConfigData.config.timebnsel === 'hrs' &&
															((!validateTime &&
																$v.testConfigData.config.timebnvalue
																	.required) ||
																testConfigData.config.timebnvalue == '0')
													"
													class="error-txt-tc"
												>
													Should be between 1 to 24
												</div>
												<div
													style="position: absolute; top: 40px; left: 9px"
													v-if="
														testConfigData.config.timebnsel === 'mins' &&
															((!validateTime &&
																$v.testConfigData.config.timebnvalue
																	.required) ||
																testConfigData.config.timebnvalue == '0')
													"
													class="error-txt-tc"
												>
													Should be a whole number between 1 and 60.
												</div>

												<div
													style="position: absolute; top: 40px; left: 9px"
													v-if="
														testConfigData.config.timebnsel === 'days' &&
															((!validateTime &&
																$v.testConfigData.config.timebnvalue
																	.required) ||
																testConfigData.config.timebnvalue == '0')
													"
													class="error-txt-tc"
												>
													Should be between 1 to 365
												</div>
												<div
													style="position: absolute; top: 40px; left: 9px"
													v-else-if="
														!validTimeBetAttempts &&
															$v.testConfigData.config.timebnsel.$dirty
													"
													class="error-txt-tc"
												>
													Time between attempts can't exceed start-end time
													difference.
												</div>
												<div
													style="position: absolute; top: 40px; left: 9px"
													v-if="
														(testConfigData.config.timebnsel === 'mins' ||
															testConfigData.config.timebnsel === 'days' ||
															testConfigData.config.timebnsel === 'hrs') &&
															!$v.testConfigData.config.timebnvalue.numeric &&
															$v.testConfigData.config.timebnvalue.required
													"
													class="error-txt-tc"
												>
													Invalid number
												</div>
											</div>
										</b-col>
										<b-col
											class="mt-2"
											v-if="testConfigData.config.maxnoattempts > 1"
										>
											<div class="project-radio d-flex align-items-center mt-2">
												<b-form-radio-group
													class="priority-labels"
													:options="priorityoptions"
													v-model="testConfigData.config.priority"
													value-field="item"
													text-field="name"
													size="sm"
												></b-form-radio-group>
											</div>
										</b-col>
									</b-row>
									<b-row class="mt-3">
										<b-col cols="4" v-if="$route.name != 'myprojects'">
											<div class="pff-checkbox">
												<b-form-checkbox
													size="md"
													class="mt-3"
													name="checkbox-1"
													v-model="testConfigData.config.displayReqFirst"
												>
													Display Mandatory Questions First
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="4">
											<div class="pff-checkbox">
												<b-form-checkbox
													size="md"
													class="mt-3"
													name="checkbox-1"
													v-model="testConfigData.config.dispMarks"
												>
													Display Marks for every Questions
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="4" v-if="$route.name != 'myprojects'">
											<div class="pff-checkbox">
												<b-form-checkbox
													size="md"
													class="mt-3"
													name="checkbox-1"
													v-model="testConfigData.config.shuffle"
												>
													Randomly Shuffle Questions
												</b-form-checkbox>
											</div>
										</b-col>
									</b-row>

									<b-row class="mt-3" v-if="$route.name != 'myprojects'">
										<b-col cols="4">
											<div class="pff-checkbox">
												<b-form-checkbox
													size="md"
													class="mt-3"
													name="checkbox-1"
													v-model="testConfigData.config.dispReqStatus"
												>
													Display Mandatory Questions Icon
												</b-form-checkbox>
											</div>
										</b-col>
									</b-row>
								</div>
								<div class="d-flex tc-btnsDiv justify-content-between p-3">
									<div class="cancelpan-btn">
										<b-button @click="previoustab()" class="h-32 w-87 ml-2"
											>Previous</b-button
										>
									</div>
									<div class="d-flex">
										<div class="cancelpan-btn">
											<b-button @click="closeModal" class="h-32 w-87 ml-2"
												>Cancel</b-button
											>
										</div>
										<div class="add-btn-tc">
											<b-button
												@click="questionbehaviour(true)"
												class="h-32 w-87 ml-4"
												><span class="add-btn-tc-txt">Next</span></b-button
											>
										</div>
									</div>
								</div>
							</b-tab>

							<b-tab>
								<template #title>
									System Setup
									<img
										style="position: absolute; top: 15px"
										v-b-popover.hover.top.v-danger="{
											content: 'Please fill all the details',
										}"
										v-if="
											$v.testConfigData.config.screenCapture.$error ||
												$v.testConfigData.config.communicationTestAttempts
													.$error ||
												(testConfigData.config.enableProctoring == true &&
													testConfigData.config.enableCamera == false)
										"
										src="../../assets/projects-icons/big-warning-red.svg"
										alt=""
									/>
									<div v-if="tabIndex == 2" class="tc-tab-sel"></div>
								</template>
								<div class="pr-2 configcontent-tabs-content px-5">
									<b-row>
										<b-col>
											<div>
												<b-row>
													<b-col cols="4">
														<div class="mt-3 relativeclass pff-checkbox">
															<b-form-checkbox
																class="mt-3"
																size=" md"
																v-model="
																	testConfigData.config.communicationTest
																"
																name="checkbox-1"
																@input="checkCommunicationTestAttempts"
															>
																Communication Test
															</b-form-checkbox>
														</div>
													</b-col>
													<b-col cols="4">
														<div class="mt-3 relativeclass pff-checkbox">
															<b-form-checkbox
																class="mt-3"
																size=" md"
																v-model="testConfigData.config.enableProctoring"
																name="checkbox-1"
																@change="enableVid"
															>
																Enable Video Proctoring
															</b-form-checkbox>
														</div>
													</b-col>
												</b-row>
												<b-row>
													<b-col cols="4">
														<div class="tc-form-fields mt-3 relativeclass">
															<label class="tc-form-labels"
																>Communication Test Attempts<span
																	class="asterik"
																	>*</span
																></label
															>
															<b-form-input
																class=""
																id="input-1"
																placeholder="Enter Here"
																type="text"
																v-model.trim="
																	$v.testConfigData.config
																		.communicationTestAttempts.$model
																"
																@keypress="validateInput($event)"
																:disabled="
																	!testConfigData.config.communicationTest
																"
																:class="{
																	error:
																		$v.testConfigData.config
																			.communicationTestAttempts.$error,
																}"
															></b-form-input>
															<div
																style="position: absolute; top: 62px; left: 8px"
																v-if="
																	$v.testConfigData.config
																		.communicationTestAttempts.$dirty &&
																		!$v.testConfigData.config
																			.communicationTestAttempts.required
																"
																class="error-txt-tc"
															>
																Required
															</div>
															<div
																style="position: absolute; top: 62px; left: 8px"
																v-else-if="
																	(!$v.testConfigData.config
																		.communicationTestAttempts.between &&
																		$v.testConfigData.config
																			.communicationTestAttempts.numeric) ||
																		isNegativeCommunicationTestAttempts
																"
																class="error-txt-tc"
															>
																Should be between 1 to 5
															</div>
															<div
																style="position: absolute; top: 62px; left: 8px"
																v-else-if="
																	!$v.testConfigData.config
																		.communicationTestAttempts.numeric &&
																		$v.testConfigData.config
																			.communicationTestAttempts.required &&
																		!isNegativeCommunicationTestAttempts
																"
																class="error-txt-tc"
															>
																Not valid number
															</div>
														</div>
													</b-col>
													<b-col cols="4">
														<div class="tc-form-fields mt-3 relativeclass">
															<label class="w-303 tc-form-labels"
																>Set Image Capture Timing-Slot (Seconds)
																<span class="asterik">*</span></label
															>
															<b-form-input
																class=""
																id="input-1"
																:disabled="
																	!testConfigData.config.enableProctoring
																"
																placeholder="Enter Here"
																type="text"
																v-model.trim="
																	$v.testConfigData.config.screenCapture.$model
																"
																@keypress="validateInput($event)"
																:class="{
																	error:
																		$v.testConfigData.config.screenCapture
																			.$error,
																}"
															></b-form-input>
															<div
																style="position: absolute; top: 67px; left: 5px"
																v-if="
																	$v.testConfigData.config.screenCapture
																		.$dirty &&
																		!$v.testConfigData.config.screenCapture
																			.required
																"
																class="error-txt-tc"
															>
																Required
															</div>
															<div
																style="position: absolute; top: 67px; left: 5px"
																v-if="
																	!$v.testConfigData.config.screenCapture
																		.between &&
																		$v.testConfigData.config.screenCapture
																			.required
																"
																class="error-txt-tc"
															>
																Should be between (1, 15)
															</div>
															<div
																style="position: absolute; top: 62px; left: 8px"
																v-if="
																	!$v.testConfigData.config.screenCapture
																		.numeric &&
																		$v.testConfigData.config.screenCapture
																			.required
																"
																class="error-txt-tc"
															>
																Invalid number (decimal not allowed)
															</div>
														</div>
													</b-col>
													<b-col class="mt-3">
														<div class="mt-3 relativeclass d-flex pff-checkbox">
															<b-form-checkbox
																class="mt-3"
																size=" md"
																name="checkbox-1"
																v-model="testConfigData.config.enableCamera"
																@input="
																	selectDosAndDonts(
																		testConfigData.config.enableCamera,
																		'enableCamera'
																	)
																"
															>
																Enable Video Recording
															</b-form-checkbox>
															<img
																v-if="
																	testConfigData.config.enableCamera &&
																		testConfigData.config.enableProctoring
																"
																src="../../assets/projects-icons/popup-icon-blue.svg"
																alt=""
																id="video-enable"
																class="mt-3 ml-1"
															/>
															<b-popover
																target="video-enable"
																triggers="hover"
																placement="bottom"
																customClass="video-enable-box"
															>
																Enabled video since proctoring is enabled
															</b-popover>
														</div>
													</b-col>
												</b-row>

												<hr class="mt-4 mb-2" />
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col cols="4">
											<div class="mt-3 relativeclass pff-checkbox">
												<b-form-checkbox
													class="mt-3"
													size=" md"
													v-model="testConfigData.config.allowImageAndIdCapture"
													name="checkbox-1"
													@change="
														selectDosAndDonts(
															testConfigData.config.allowImageAndIdCapture,
															'allowImageAndIdCapture'
														)
													"
												>
													Allow Image And ID Capture
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="4">
											<div class="mt-3 relativeclass pff-checkbox">
												<b-form-checkbox
													class="mt-3"
													size=" md"
													name="checkbox-1"
													v-model="testConfigData.config.typingTest"
												>
													Typing Test
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="4" v-if="$route.name != 'myprojects'">
											<div class="mt-3 relativeclass pff-checkbox">
												<b-form-checkbox
													class="mt-3"
													size=" md"
													name="checkbox-1"
													v-model="testConfigData.config.instantemail"
													@change="
														selectDosAndDonts(
															testConfigData.config.instantemail,
															'instantemail'
														)
													"
													>Instant Test Result
												</b-form-checkbox>
											</div>
										</b-col>

										<b-col cols="4">
											<div class="Div mt-3 relativeclass pff-checkbox">
												<b-form-checkbox
													class="mt-3"
													size=" md"
													v-model="testConfigData.config.allowAgent"
													name="checkbox-1"
													@change="
														selectDosAndDonts(
															testConfigData.config.allowAgent,
															'allowAgent'
														)
													"
													>Allow Agent
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="4">
											<div class="mt-3 relativeclass pff-checkbox">
												<b-form-checkbox
													class="mt-3"
													size=" md"
													name="checkbox-1"
													v-model="testConfigData.config.allowCandidateRemarks"
												>
													Allow Candidate Feedback
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="4" v-if="$route.name != 'myprojects'">
											<div class="mt-3 relativeclass pff-checkbox">
												<b-form-checkbox
													class="mt-3"
													v-model="testConfigData.config.enableScreenShare"
													size=" md"
													name="checkbox-1"
													@change="
														selectDosAndDonts(
															testConfigData.config.enableScreenShare,
															'enableScreenShare'
														)
													"
												>
													Enable Screen Share
												</b-form-checkbox>
											</div>
										</b-col>

										<b-col cols="4">
											<div class="mt-3 relativeclass pff-checkbox">
												<b-form-checkbox
													class="mt-3"
													size=" md"
													v-model="testConfigData.config.includeTimeNotifics"
													name="checkbox-1"
												>
													Include Time Sensitivity Notifications
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="4">
											<div class="mt-3 relativeclass pff-checkbox">
												<b-form-checkbox
													class="mt-3"
													v-model="testConfigData.config.allowExtension"
													size=" md"
													name="checkbox-1"
													@change="
														selectDosAndDonts(
															testConfigData.config.allowExtension,
															'allowExtension'
														)
													"
												>
													Allow Extension
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="4">
											<div class="mt-3 relativeclass pff-checkbox">
												<b-form-checkbox
													class="mt-3"
													size=" md"
													name="checkbox-1"
													v-model="testConfigData.config.internetCheck"
												>
													<div class="">Enable Internet Check</div>
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="4">
											<div class="mt-3 relativeclass pff-checkbox">
												<b-form-checkbox
													class="mt-3"
													size=" md"
													name="checkbox-1"
													v-model="testConfigData.config.allowLocation"
												>
													<div class="">Allow Location</div>
												</b-form-checkbox>
											</div>
										</b-col>
									</b-row>
								</div>
								<div class="d-flex tc-btnsDiv justify-content-between p-3">
									<div class="cancelpan-btn">
										<b-button @click="previoustab()" class="h-32 w-87 ml-2"
											>Previous</b-button
										>
									</div>
									<div class="d-flex">
										<div class="cancelpan-btn">
											<b-button @click="closeModal" class="h-32 w-87 ml-2"
												>Cancel</b-button
											>
										</div>
										<div class="add-btn-tc">
											<b-button
												@click="systemSetup(true)"
												class="h-32 w-87 ml-4"
												><span class="add-btn-tc-txt">Next</span></b-button
											>
										</div>
									</div>
								</div>
							</b-tab>
							<b-tab>
								<template #title>
									Do’s and Dont’s
									<img
										style="position: absolute; top: 15px"
										v-b-popover.hover.top.v-danger="{
											content: 'Please fill all the details',
										}"
										v-if="$v.testConfigData.config.dosAndDonts.$error"
										src="../../assets/projects-icons/big-warning-red.svg"
										alt=""
									/>
									<div v-if="tabIndex == 3" class="tc-tab-sel"></div>
								</template>
								<div
									class="pr-2 configcontent-tabs-content position-relative px-5"
								>
									<draggable
										tag="div"
										group="trueexpdata"
										:list="testConfigData.config.dosAndDonts"
										class="pointer"
									>
										<div class="dos-donts-head-tc">Do's & Dont’s</div>
										<div class="dos-donts-head-tc fw-400">
											(Min 1 required)<span class="asterik">*</span>
										</div>

										<div
											v-for="(i, index) in testConfigData.config.dosAndDonts"
											:key="index"
											class="mt-3"
										>
											<div class="d-flex position-relative">
												<div
													class="d-flex dos-donts-fields w-96 position-relative mb-1"
												>
													<div class="mr-2 mt-2">
														<span class="dos-donts-num">{{ index + 1 }}. </span>
													</div>
													<b-form-input
														autofocus
														class="pointer"
														placeholder="Enter"
														v-model.trim="
															$v.testConfigData.config.dosAndDonts.$each[index]
																.value.$model
														"
														:class="{
															error:
																$v.testConfigData.config.dosAndDonts.$each[
																	index
																].value.$error,
														}"
														type="text"
														@keyup.enter="addOptions"
													></b-form-input>
												</div>
												<div
													class="jd-validicon-tc"
													v-if="
														$v.testConfigData.config.dosAndDonts.$each[index]
															.value.$dirty &&
															!$v.testConfigData.config.dosAndDonts.$each[index]
																.value.required
													"
												>
													<span class="error-txt-tc">Required</span>
												</div>
												<div
													class="jd-validicon-tc"
													v-if="
														!$v.testConfigData.config.dosAndDonts.$each[index]
															.value.maxLength &&
															$v.testConfigData.config.dosAndDonts.$each[index]
																.value.required
													"
												>
													<span class="error-txt-tc"
														>Should not exceed 512 characters</span
													>
												</div>
												<div
													v-if="
														index ==
															testConfigData.config.dosAndDonts.length - 1
													"
													class="tc-dodont-del-pos m-1 px-1"
												>
													<!-- <img
                            v-if="
                              !$v.testConfigData.config.dosAndDonts.$each[index]
                                .value.$dirty ||
                              !$v.testConfigData.config.dosAndDonts.$each[index]
                                .value.required
                            "
                            src="../../assets/img/config-modules/disable-DandDs.svg"
                            alt=""
                          /> -->
													<img
														@click="addOptions"
														src="../../assets/config-icons/add-dos-donts.svg"
														alt=""
													/>
												</div>
												<div
													class="tc-dodont-del-pos m-1 px-1"
													v-else-if="
														testConfigData.config.dosAndDonts.length > 1
													"
												>
													<img
														@click="deleteOption(index)"
														src="../../assets/projects-icons/purple-bin.svg"
														alt=""
													/>
												</div>
											</div>
										</div>
									</draggable>
									<div v-if="errorstatus" class="text-center mt-3">
										<span class="asterik"
											>*please fill mandatory fields in all tabs</span
										>
									</div>
								</div>
								<div class="d-flex tc-btnsDiv justify-content-between p-3">
									<div class="cancelpan-btn">
										<b-button @click="previoustab()" class="h-32 w-87 ml-2"
											>Previous</b-button
										>
									</div>
									<div class="d-flex">
										<div class="cancelpan-btn">
											<b-button @click="closeModal" class="h-32 w-87 ml-2"
												>Cancel</b-button
											>
										</div>
										<div class="add-btn-tc">
											<b-button
												@click="checkConfigValidations"
												class="h-32 w-150 ml-4"
												><span class="add-btn-tc-txt">Update</span></b-button
											>
										</div>
									</div>
								</div>
							</b-tab>
						</b-tabs>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal
			id="confirm-edit"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img class="pr-3" src="../../assets/caution.svg" alt="" />
			</div>
			<div @click="$bvModal.hide('confirm-edit')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to edit ?</span>
			</div>
			<div class="mt-2 caution-modal-text">
				This configuration is tagged to more than one group. Do you want to
				crezte a new configuration or confirm the action?
			</div>
			<div class="mt-2 normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn mr-2" @click="addConfig()">Create New</b-button>
				<div @click="confirm()" class="sec-canceltext pointer">Confirm</div>
			</div>
		</b-modal>
	</div>
</template>
<script>
import {
	getConfig,
	postTaggedGroup,
	dosanddontslist,
	editConfig,
	addConfig,
} from "../../utils/apiFunctions.js";
import {
	required,
	requiredIf,
	numeric,
	between,
	maxLength,
	helpers,
} from "vuelidate/lib/validators";
import { DateTime as LuxonDateTime } from "luxon";
import QuillEditor from "../../components/forms/quillEditor.vue"; //Quill editor from component
import draggable from "vuedraggable";
import toastFunction from "../mixin/toast";

import { mapGetters } from "vuex";
import SingleSelect from "../../components/InputComponents/SingleSelect.vue";

const betweenTestDuration = () => {
	const isMyProjectsRoute = window.location.pathname.includes("/myprojects");
	return isMyProjectsRoute ? between(5, 1440) : between(5, 360);
};

const betweenBufferTime = () => {
	const isMyProjectsRoute = window.location.pathname.includes("/myprojects");
	return isMyProjectsRoute ? between(0, 1440) : between(0, 360);
};

export default {
	data() {
		return {
			groups: null,
			sideConfig: false,
			showConfigModal: false,
			showTagged: true,
			testConfigData: { config: {}, configName: "" },
			openIndex: 0,
			selectedGroup: {
				groupName: "",
				createdAt: "",
				candidates: [],
				evaluator: [],
			},
			fieldsinvalidosd: false,
			fieldsinvalidqb: false,
			fieldsinvalidss: false,
			defaultdosanddonts: [],
			viewTaggedModal: false,
			testoption: {},
			testoptError: false,
			addques1: false,

			testoptions: [
				{
					value: "public",
					text: "Public",
				},
				{
					value: "private",
					text: "Private",
				},
			],
			timeoptions: [
				{
					value: "mins",
					text: "Minutes",
				},
				{
					value: "hrs",
					text: "Hours",
				},
				{
					value: "days",
					text: "Days",
				},
			],
			tabIndex: 0,
			priorityoptions: [
				{
					item: "first",
					name: "First",
				},
				{
					item: "last",
					name: "Last",
				},
				{
					item: "highestScored",
					name: "Highest Scored",
				},
			],
			errorstatus: false,
			timeattempts: false,
			dirtyCheckDescQuestion: false,
			startdatetime: LuxonDateTime.local()
				.minus({ month: 0, days: 0 })
				.toISO(),
		};
	},
	mixins: [toastFunction],

	props: {
		testID: {
			type: String,
			default: null,
		},
		topicID: {
			type: String,
			default: null,
		},
	},
	validations() {
		return {
			testConfigData: {
				configName: {
					required,
					maxLength: maxLength(128),
				},
				name: {
					required,
					maxLength: maxLength(128),
				},
				config: {
					testOrg: {
						required,
						maxLength: maxLength(128),
					},
					testDesc: {
						required,
						maxLength: maxLength(1024),
					},
					testInst: {
						maxLength: maxLength(256),
					},
					test: {
						required,
					},
					quesPerScreen: {
						required,
						between: between(1, 10),
						numeric,
					},
					negativeMarkValue: {
						required,
						between: between(0, 30),
						numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
					},
					passingPercentage: {
						required,
						between: between(1, 100),
						numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
					},
					testDuration: {
						required,
						between: betweenTestDuration(),
						alpha: helpers.regex("alpha", /^\d{0,4}(\.\d{0,2})?$/),
						numeric: helpers.regex("numeric", /^(-)?\d{0,4}(\.\d{0,2})?$/),
					},
					openTestdt: {
						required,
					},
					closeTestdt: {
						required,
						isDateValid: (value) => {
							const selectedDate = new Date(value);
							const currentDate = new Date();
							if (selectedDate == "Invalid Date") return true;
							else return selectedDate > currentDate;
						},
					},
					dosAndDonts: {
						$each: {
							value: {
								required,
								maxLength: maxLength(256),
							},
						},
					},

					maxnoattempts: {
						required,
						numeric,
						between: between(1, 10),
					},
					buffertime: {
						required,
						numeric: helpers.regex("numeric", /^\d{1,4}\.?\d{0,2}$/),
						between: betweenBufferTime(),
					},
					timebnvalue: {
						required: requiredIf(function() {
							return (
								this.testConfigData.config.maxnoattempts >= 2 &&
								this.testConfigData.config.timebnsel != ""
							);
						}),
						Validate: this.validateTime,
						numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
					},
					timebnsel: {
						required: requiredIf(function() {
							return this.testConfigData.config.maxnoattempts >= 2;
						}),
					},
					screenCapture: {
						required: requiredIf(function() {
							return this.testConfigData.config.enableProctoring;
						}),
						numeric,
						between: between(1, 15),
					},
					communicationTestAttempts: {
						required: requiredIf(function() {
							return this.testConfigData.config.communicationTest;
						}),
						between: between(1, 5),
						numeric,
					},
				},
			},
		};
	},
	components: { SingleSelect, QuillEditor, draggable },
	computed: {
		...mapGetters(["roles"]),
		validateTime() {
			if (this.testConfigData.config?.maxnoattempts > 1) {
				if (
					this.testConfigData.config?.timebnsel === "hrs" &&
					this.testConfigData.config?.timebnvalue > 0 &&
					this.testConfigData.config?.timebnvalue <= 24
				) {
					return true;
				} else if (
					this.testConfigData.config?.timebnsel === "mins" &&
					this.testConfigData.config?.timebnvalue >= 1 &&
					this.testConfigData.config?.timebnvalue <= 60 && 
					this.testConfigData.config.timebnvalue % 1 === 0
				) {
					return true;
				} else if (
					this.testConfigData.config?.timebnsel === "days" &&
					this.testConfigData.config?.timebnvalue >= 1 &&
					this.testConfigData.config?.timebnvalue <= 365
				) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		},
		validTimeBetAttempts() {
			if (
				this.testConfigData.config.openTestdt &&
				this.testConfigData.config.closeTestdt &&
				this.testConfigData.config.maxnoattempts > 1
			) {
				const startDate = new Date(this.testConfigData.config.openTestdt);
				const endDate = new Date(this.testConfigData.config.closeTestdt);
				const timeDiffInMilliseconds = endDate.getTime() - startDate.getTime();
				let timeDiff;
				if (this.testConfigData.config.timebnsel === "hrs") {
					timeDiff = timeDiffInMilliseconds / (1000 * 60 * 60);
				} else if (this.testConfigData.config.timebnsel === "mins") {
					timeDiff = timeDiffInMilliseconds / (1000 * 60);
				} else if (this.testConfigData.config.timebnsel === "days") {
					timeDiff = timeDiffInMilliseconds / (1000 * 60 * 60 * 24);
				}
				return this.testConfigData.config.timebnvalue <= timeDiff;
			} else {
				return true;
			}
		},
		isNegativeCommunicationTestAttempts() {
			const attempts = parseInt(
				this.testConfigData.config.communicationTestAttempts
			);
			return !isNaN(attempts) && attempts < 0;
		},
	},
	created() {
		this.getdosanddonts();
		this.getGroups();
	},
	watch: {
		testID() {
			this.getdosanddonts();
			this.getGroups();
		},
	},
	methods: {
		async getdosanddonts() {
			try {
				const res = await dosanddontslist();
				if (res.status == 200) {
					let data = res.data.data;
					for (let i in data) {
						if (data[i].type == "Dos and Donts") {
							this.defaultdosanddonts = data[i].codeList;
						}
					}
				}
			} catch (error) {
				throw new Error(`Failed! Error :${error}`);
			}
		},
		goToSharePage() {
			this.$router.push({
				name: "sharesandbox",
				params: {
					testID: this.testID,
					topicID: this.topicID,
				},
				query: {
					type: 4,
					testqp: "outside",
					groupType: "I",
				},
			});
		},
		openModal(data) {
			this.testoption.value = this.testConfigData.config.test;
			this.testoption.text =
				this.testConfigData.config.test.charAt(0).toUpperCase() +
				this.testConfigData.config.test.slice(1);

			this.tabIndex = data;
			this.$v.$reset();
			this.showConfigModal = true;
		},
		openDate(ref) {
			this.$refs[ref].$el.children[0].click();
		},
		timeDiffMinutes() {
			if (
				this.testConfigData.config.openTestdt &&
				this.testConfigData.config.closeTestdt
			) {
				const startDate = new Date(this.testConfigData.config.openTestdt);
				const endDate = new Date(this.testConfigData.config.closeTestdt);
				const timeDiff = endDate.getTime() - startDate.getTime();

				if (this.testConfigData.config.testDuration !== null) {
					return (
						this.testConfigData.config.testDuration >
						Math.floor(timeDiff / (1000 * 60))
					);
				}
				return false;
			}
			return null;
		},
		confirm() {
			this.saveExistConfig(true);
		},
		hoursDiffAttempts() {
			if (
				this.testConfigData.config.openTestdt &&
				this.testConfigData.config.closeTestdt
			) {
				const startDate = new Date(this.testConfigData.config.openTestdt);
				const endDate = new Date(this.testConfigData.config.closeTestdt);
				const timeDiff = endDate.getTime() - startDate.getTime();

				if (this.testConfigData.config.testDuration !== null) {
					const hoursDiff = timeDiff / (1000 * 60 * 60);
					return hoursDiff > 24;
				}
				return false;
			}

			return null;
		},
		minutesDiffAttempts() {
			if (
				this.testConfigData.config.openTestdt &&
				this.testConfigData.config.closeTestdt
			) {
				const startDate = new Date(this.testConfigData.config.openTestdt);
				const endDate = new Date(this.testConfigData.config.closeTestdt);
				const timeDiffInMilliseconds = endDate.getTime() - startDate.getTime();
				const timeDiffInHours = timeDiffInMilliseconds / (1000 * 60 * 60);

				if (this.testConfigData.config.testDuration !== null) {
					return timeDiffInHours > 1;
				}
				return false;
			}

			return null;
		},
		checkCondition() {
			if (this.testConfigData.config.test == "") {
				this.testoptError = true;
			} else this.testoptError = false;

			this.openscreen(true);
			if (
				this.$v.testConfigData.config.testDesc.$invalid ||
				this.dirtyCheckDescQuestion
			) {
				this.dirtyCheckDescQuestion = true;
			}
		},
		checkConfigValidations() {
			this.openscreen(false);
			this.questionbehaviour(false);
			this.systemSetup(false);
			this.$v.testConfigData.config.dosAndDonts.$touch();
			if (
				!this.fieldsinvalidosd &&
				!this.fieldsinvalidqb &&
				!this.fieldsinvalidss &&
				!this.$v.testConfigData.config.dosAndDonts.$invalid
			) {
				if (
					this.testConfigData.config.timebnsel != "" &&
					this.testConfigData.config.timebnsel != null
				) {
					if (this.testConfigData.config.timebnsel == "hrs") {
						this.testConfigData.config.timebetweenattempts =
							this.testConfigData.config.timebnvalue * 60;
					} else if (this.testConfigData.config.timebnsel == "days") {
						this.testConfigData.config.timebetweenattempts =
							this.testConfigData.config.timebnvalue * 1440;
					} else {
						this.testConfigData.config.timebetweenattempts = this.testConfigData.config.timebnvalue;
					}
					this.testConfigData.config.timebetweenattempts = this.testConfigData.config.timebetweenattempts.toString();
				}
				// this.testConfigData.config.openTestdt = convertTime(
				//   this.testConfigData.config.openTestdt,
				//   "utc"
				// );
				// this.testConfigData.config.closeTestdt = convertTime(
				//   this.testConfigData.config.closeTestdt,
				//   "utc"
				// );

				this.saveExistConfig();
			} else {
				this.errorstatus = true;
			}
		},
		validateText(val) {
			this.dirtyCheckDescQuestion = val;
		},
		updateQuestionContent(newContent) {
			this.testConfigData.config.testDesc = newContent;
		},
		changedaddQues(newval) {
			this.addques1 = newval;
		},
		isBetweenContentTag(element) {
			return element.textContent.trim() !== "";
		},
		getDesiredContent(contentType) {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML =
				contentType === "testDesc" ? this.testConfigData.config.testDesc : "";
			const pTags = tempDiv.querySelectorAll("p");

			let endIndex = pTags.length;

			for (let i = pTags.length - 1; i >= 0; i--) {
				if (this.isBetweenContentTag(pTags[i])) {
					endIndex = i + 1;
					break;
				}
			}

			pTags.forEach((pTag, index) => {
				if (index >= endIndex && !pTag.textContent.trim()) {
					tempDiv.removeChild(pTag);
				}
			});

			if (contentType === "testDesc") {
				this.testConfigData.config.testDesc = tempDiv.innerHTML;
			}
		},
		async addConfig() {
			this.$v.testConfigData.config.$touch();
			try {
				if (
					!this.dirtyCheckDescQuestion &&
					!this.$v.testConfigData.config.$invalid
				) {
					this.errorstatus = false;
					if (
						this.testConfigData.config.timebnsel != "" &&
						this.testConfigData.config.timebnsel != null
					) {
						if (this.testConfigData.config.timebnsel == "hrs") {
							this.testConfigData.config.timebetweenattempts =
								this.testConfigData.config.timebnvalue * 60;
						} else if (this.testConfigData.config.timebnsel == "days") {
							this.testConfigData.config.timebetweenattempts =
								this.testConfigData.config.timebnvalue * 1440;
						} else {
							this.testConfigData.config.timebetweenattempts = this.testConfigData.config.timebnvalue;
						}
					}
					let payload = {
						portion: "Config",
						testID: this.testID,
						name: this.testConfigData.configName,
						groupID: this.selectedGroup.groupID,
						config: this.testConfigData.config,
					};
					if (this.$route.name == "myprojects") {
						payload.config.dispCount = false;
						payload.config.quesPerScreen = "1";
						payload.config.shuffle = false;
						payload.config.dispReqStatus = false;
						payload.config.displayReqFirst = false;
						payload.config.dispMarks = true;
						payload.config.negativeMarkValue = "0";
						payload.config.buffertime = payload.config.testDuration;
						payload.config.enableScreenShare = false;
						payload.config.communicationTestDuration = "45";
						payload.config.typingDuration = "60";
						payload.config.includeEndTest = true;
						payload.config.instantemail = false;
						payload.config["configType"] = "sandbox";
					}
					const res = await addConfig(payload);
					if (res.status == 200) {
						this.successToast("Configuration added successfully");
						this.$bvModal.hide("confirm-edit");
						this.$bvModal.hide("modal-config");
						this.getConfiguration(res.data.data.ConfigID);
					} else {
						this.errorToast(res.data.data.Data);
						this.$bvModal.hide("confirm-edit");
					}
				} else {
					this.errorstatus = true;
				}
			} catch (error) {
				throw new Error(`Failed! Error :${error}`);
			}
		},
		async saveExistConfig(force = false) {
			try {
				this.saveconfigvalid();
				console.log(
					"this.$v.testConfigData.config.$invalid",
					this.$v.testConfigData.config.$invalid,
					this.$v.testConfigData.config
				);
				if (
					!this.$v.testConfigData.config.$invalid &&
					!this.dirtyCheckDescQuestion &&
					!(
						this.testConfigData.config.enableProctoring &&
						!this.testConfigData.config.enableCamera
					)
				) {
					this.saveconfigapi(force);
					this.errorstatus = false;
				} else {
					this.errorstatus = true;
					if (this.testinstruction == "not_accepted") {
						this.dirtyCheckQuestion = false;
						if (
							this.$v.testConfigData.config.testDesc.$invalid ||
							this.dirtyCheckDescQuestion
						) {
							this.dirtyCheckDescQuestion = true;
						}
					}
				}
			} catch (error) {
				if (error.response.status == 409) {
					this.$bvModal.show("confirm-edit");
				} else {
					this.errorToast(error.response.data.data.Details);
				}
				throw new Error(`Failed! Error :${error}`);
			}
		},
		saveconfigvalid() {
			if (this.testConfigData.config.configType !== "sandbox") {
				if (!this.testConfigData.config.dispCount) {
					this.testConfigData.config.dispCount = true;
				}
			}
			if (!this.testConfigData.config.dispDuration) {
				this.testConfigData.config.dispDuration = true;
			}
			if (!this.testConfigData.config.includeEndTest) {
				this.testConfigData.config.includeEndTest = true;
			}
			this.$v.$touch();
			if (this.testinstruction == "not_accepted") {
				this.globalWorks = true;
			}
		},
		async saveconfigapi(force = false) {
			if (
				this.testConfigData.config.timebnsel != "" &&
				this.testConfigData.config.timebnsel != null
			) {
				if (this.testConfigData.config.timebnsel == "hrs") {
					this.testConfigData.config.timebetweenattempts =
						this.testConfigData.config.timebnvalue * 60;
				} else if (this.testConfigData.config.timebnsel == "days") {
					this.testConfigData.config.timebetweenattempts =
						this.testConfigData.config.timebnvalue * 1440;
				} else {
					this.testConfigData.config.timebetweenattempts = this.testConfigData.config.timebnvalue;
				}
			}
			let payload = {
				configID: this.testConfigData.configID,
				config: {
					...this.testConfigData.config,
					buffertime: this.testConfigData.config.testDuration,
				},
				name: this.testConfigData.configName,
				check: !force,
			};
			console.log(this.testConfigData, "testConfigData");
			const res = await editConfig(payload);

			if (res.status == 200) {
				this.$nextTick(() => {
					this.successToast("Configuration updated successfully");
				});
				this.$bvModal.hide("confirm-edit");
				this.$bvModal.hide("modal-config");
				this.addques1 = true;
				this.addques2 = true;
				this.dirtyCheckDescQuestion = false;
				this.dirtyCheckQuestion = false;
				this.getConfiguration(this.testConfigData.configID);

				this.$bvModal.hide("modal-config");
			} else if (res.status == 409) {
				this.$bvModal.show("confirm-edit");
			}
		},
		selectDosAndDonts(value, id) {
			for (let i in this.dosAndDontsList) {
				if (value) {
					if (
						this.testConfigData.config.dosAndDonts.length > 0 &&
						this.testConfigData.config.dosAndDonts[0].value == ""
					) {
						this.testConfigData.config.dosAndDonts.splice(0, 1);
					}
					if (this.dosAndDontsList[i].value == id) {
						this.testConfigData.config.dosAndDonts.push({
							value: "",
							code: "",
						});
						this.testConfigData.config.dosAndDonts[
							this.testConfigData.config.dosAndDonts.length - 1
						].code = this.dosAndDontsList[i].value;
						this.testConfigData.config.dosAndDonts[
							this.testConfigData.config.dosAndDonts.length - 1
						].value = this.dosAndDontsList[i].description;
					}
				} else {
					for (let j in this.testConfigData.config.dosAndDonts) {
						if (this.testConfigData.config.dosAndDonts[j].code == id) {
							this.testConfigData.config.dosAndDonts.splice(j, 1);
						}
						if (this.testConfigData.config.dosAndDonts.length == 0) {
							this.testConfigData.config.dosAndDonts.push({
								value: "",
								code: "",
							});
						}
					}
				}
			}
		},

		viewGroupInfo(group) {
			this.selectedGroup = group;
			this.$bvModal.show("viewgroup-1");
		},
		previoustab() {
			this.tabIndex--;
		},
		validateInput(event) {
			const charCode = event.keyCode || event.which;
			const charTyped = String.fromCharCode(charCode);
			const regex = /^(?!0{2,})\d{1,4}(?:\.\d{0,2})?$/;
			if (!regex.test(event.target.value + charTyped)) {
				event.preventDefault();
			}
		},
		openscreen(flag) {
			if (
				this.$v.testConfigData.config.testDesc.$invalid ||
				this.dirtyCheckDescQuestion
			) {
				this.dirtyCheckDescQuestion = true;
			}
			this.$v.testConfigData.config.testOrg.$touch();
			this.$v.testConfigData.configName.$touch();
			if (
				(!this.dirtyCheckDescQuestion ||
					!this.$v.testConfigData.config.testDesc.$invalid) &&
				!this.$v.testConfigData.config.testOrg.$invalid &&
				!this.$v.testConfigData.configName.$invalid &&
				this.testConfigData.config.test != ""
			) {
				if (flag) {
					this.tabIndex++;
				}
				this.fieldsinvalidosd = false;
			} else {
				this.fieldsinvalidosd = true;
			}
		},
		questionbehaviour(flag) {
			this.$v.testConfigData.config.passingPercentage.$touch();
			this.$v.testConfigData.config.negativeMarkValue.$touch();
			this.$v.testConfigData.config.maxnoattempts.$touch();
			this.$v.testConfigData.config.buffertime.$touch();

			this.$v.testConfigData.config.quesPerScreen.$touch();
			this.$v.testConfigData.config.timebnvalue.$touch();
			this.$v.testConfigData.config.timebnsel.$touch();

			this.$v.testConfigData.config.testDuration.$touch();
			this.$v.testConfigData.config.openTestdt.$touch();
			this.$v.testConfigData.config.closeTestdt.$touch();
			const skipValidtation = this.$route.name != "myprojects";

			if (
				!this.$v.testConfigData.config.passingPercentage.$invalid &&
				!this.$v.testConfigData.config.negativeMarkValue.$invalid &&
				!this.$v.testConfigData.config.maxnoattempts.$invalid &&
				!this.$v.testConfigData.config.timebnsel.$invalid &&
				!this.$v.testConfigData.config.timebnvalue.$invalid &&
				!this.$v.testConfigData.config.quesPerScreen.$invalid &&
				!this.$v.testConfigData.config.testDuration.$invalid &&
				!this.$v.testConfigData.config.openTestdt.$invalid &&
				!this.$v.testConfigData.config.closeTestdt.$invalid &&
				this.$v.testConfigData.config.closeTestdt.isDateValid
			) {
				if (!skipValidtation) {
					if (
						!this.$v.testConfigData.config.quesPerScreen.$invalid &&
						!this.$v.testConfigData.config.negativeMarkValue.$invalid &&
						!this.$v.testConfigData.config.buffertime.$invalid
					) {
						if (flag) {
							this.tabIndex++;
						}
					}
				}

				this.fieldsinvalidqb = false;
			} else {
				this.fieldsinvalidqb = true;
			}
		},
		systemSetup(flag) {
			this.$v.testConfigData.config.screenCapture.$touch();
			this.$v.testConfigData.config.communicationTestAttempts.$touch();
			if (
				!this.$v.testConfigData.config.screenCapture.$invalid &&
				!this.$v.testConfigData.config.communicationTestAttempts.$invalid
			) {
				this.fieldsinvalidss = false;
				if (this.testConfigData.config.enableProctoring) {
					if (this.testConfigData.config.enableCamera && flag) {
						this.tabIndex++;
					}
				} else if (flag) {
					this.tabIndex++;
				}
			} else {
				this.fieldsinvalidss = true;
			}
		},
		checkCommunicationTestAttempts() {
			if (!this.testConfigData.config.communicationTest) {
				this.testConfigData.config.communicationTestAttempts = null;
			}
		},
		addOptions() {
			this.testConfigData.config.dosAndDonts.push({
				value: "",
			});
		},
		deleteOption(i) {
			this.testConfigData.config.dosAndDonts.splice(i, 1);
			this.$v.testConfigData.config.dosAndDonts.$reset();
		},
		checkMaxAttempts() {
			if (parseInt(this.testConfigData.config.maxnoattempts) < 2) {
				this.testConfigData.config.timebnsel = "";
				this.testConfigData.config.timebnvalue = "";
			}
		},
		closeModal() {
			this.$v.testConfigData.$reset();
			this.dirtyCheckDescQuestion = false;
			this.$bvModal.hide("modal-config");
		},
		enableVid() {
			if (this.testConfigData.config.enableProctoring) {
				this.testConfigData.config.enableCamera = true;
			}
		},
		closeTime() {
			this.timeattempts = false;
		},

		getITCDateTime(utcDateTime) {
			const utcDate = new Date(utcDateTime);
			const options = {
				timeZone: "Asia/Kolkata",
				day: "2-digit",
				month: "2-digit",
				year: "numeric",
				hour: "2-digit",
				minute: "2-digit",
			};
			const itcDate = utcDate
				.toLocaleString("en-IN", options)
				.replace(/\//g, "-");
			return itcDate;
		},

		async getGroups() {
			try {
				let payload = {
					tag: "1",
					page: 0,
					count: "all",
					testID: this.testID,
				};
				const res = await postTaggedGroup(payload);
				if (res.status == 200) {
					this.groups = res.data.data.data;
				}
			} catch (error) {
				throw new Error(`Failed! Error :${error}`);
			}
			this.showSpinner = false;
		},
		openSideConfig(configID) {
			this.getConfiguration(configID);
			console.log(configID);
		},
		async getConfiguration(configID) {
			console.log();
			const res = await getConfig(configID);
			if (res.status == 200) {
				this.testConfigData = res.data.data;
				this.testConfigData.config.typingDuration = 60;
				this.testConfigData.configName = res.data.data.configName;
				this.sideConfig = true;
				this.showTagged = false;
			}
		},
		openSelectedTab(data) {
			this.tabIndex = data;
			this.$v.$reset();
			//   this.$bvModal.show("sideConfigModal");
		},
		updateOpenIndex(index) {
			console.log(index, "event");
			this.openIndex = this.openIndex == index ? null : index;
		},
	},
};
</script>
<style scoped>
.tagged-cards {
	height: 50px;
	padding: 10px;
	background: #fafafa;
	border: 1px solid rgba(140, 140, 140, 0.33);
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #272727;
}
.config-cards {
	padding: 16px 12px;
	gap: 10px;
	background: #ffffff;
	border: 1px solid rgba(140, 140, 140, 0.33);
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #272727;
}
.openconfig-cards {
	background: #e1eef7;
}
.screendisplay-content {
	background: #ffffff;
	border: 1px solid rgba(140, 140, 140, 0.33);
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
}
.ts-sideconfg-heading {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	color: #3a3c40;
}
.ts-sideconfg-content {
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 14px;
	color: #3a3c40;
}
.testconfig-btns {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #272727;
}
.modalhead-sm {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 18px;
	color: #000000;
}
.groupheading {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 18px;
	color: #333333;
}
.shareview-details {
	background: rgba(114, 115, 142, 0.1);
}
.sm-cards {
	border: 1px solid rgba(140, 140, 140, 0.33);
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
	margin: 0px 10px 20px 10px;
}
.sm-card-head {
	font-family: "Lato", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	color: #333333;
}
.sm-date {
	font-family: "Lato", sans-serif;
	font-style: italic;
	font-weight: 500;
	font-size: 13px;
	color: rgba(140, 140, 140, 0.5);
}
.stc-view-grp-overflow {
	padding: 0px 15px 10px 15px;
}
.stc-share-viewgroup-container {
	min-height: auto;
	max-height: calc(100vh - 727px);
	overflow-y: auto;
}
.active-bubble {
	width: 76px;
	height: 29px;
	padding: 6px 16px;
	background: rgba(3, 142, 0, 0.1);
	border-radius: 15px;
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #038e00;
}
</style>
<style>
.right-container h2 {
	font-family: var(--Montserrat);
	font-weight: var(--weight-M);
	font-size: var(--size-16);
	color: #344054;
	margin: 0;
	line-height: 24px;
}

.right-container-head {
	font-family: var(--Montserrat);
	font-weight: var(--weight-LM);
	font-size: 13px;
	color: #3a3c40;
}

.right-container-subhead {
	font-family: var(--Montserrat);
	font-weight: var(--weight-M);
	font-size: var(--size-14);
	color: #3a3c40;
}

.right-container-tags {
	background: rgba(114, 115, 142, 0.1);
	border-radius: 14.7861px;
	font-family: var(--Montserrat);
	font-weight: var(--weight-R);
	font-size: 12px;
	color: var(--navy-blue);
	padding: 4px 12px;
}
#viewgroup-1 .modal-body {
	padding: 0rem;
	width: 600px;
}
#viewgroup-1 .modal-content {
	width: 600px;
}
.xMark-pos {
	position: absolute;
	top: 16px;
	right: 17px;
	cursor: pointer;
}

.configuration-topDiv > .inputField {
	font-family: "Poppins", sans-serif;
	border: 1px solid #bbbbbb;
	border-radius: 3px !important;
	font-size: var(--size-12);
	color: #6d6d6d;
	box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
	box-sizing: border-box;
}
.cj-test-section-tabs .tab-pane {
	height: calc(100vh - 200px);
	overflow-x: hidden;
	overflow-y: auto;
}

.cj-test-section-tabs .nav-tabs {
	background: #faf9f9;
	border: 1px solid #e7e7e7;
	border-radius: 10px;
	width: 100%;
}

.cj-test-section-tabs .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
	color: white;
	background: #72738e;
	border-radius: 10px;
	font-weight: 600;
	font-size: 14px;
	text-align: center;
	padding: 7px 79px;
	position: relative;
}

.cj-test-section-tabs .nav-tabs .nav-link {
	font-weight: var(--weight-LM);
	font-size: var(--size-14);
	padding: 7px 73px;
	position: relative;
	min-width: 150px;

	color: var(--btn-border);
	margin-bottom: none;
	border: none;
	border-top-left-radius: none;
	border-top-right-radius: none;
	text-align: center;
}
.prev-btn {
	position: absolute;
	bottom: 10px;
	left: 9px;
}
.testconfig-topDiv-name > .inputField {
	border: 0.7px solid var(--input-border);
	border-radius: 3px !important;
	font-size: 14px;
	background: var(--bg-inputfield);
	color: #6d6d6d;
	box-sizing: border-box;
	padding: 0.5rem 0.75rem;
	padding-right: 2rem;
	height: calc(1.5em + 0.75rem + 2px);
}

.startdateconfig-tc > input {
	border: 1px solid #d0d5dd;
	padding: 10px 14px 10px 14px;
	/* width: 300px; */
	height: 37px;
	border-radius: 8px;
	width: 100%;
}
.cs-left-modal-back {
	background-color: #72738e;
	width: 6%;
	border-radius: 15px 0px 0px 15px;
}
.body-div-right-tc {
	width: 94%;
}

.pan-log-tabs-tc {
	height: calc(100vh - 156px);
}

.pan-log-tabs-tc .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
	font-weight: 700;
	font-size: 16px;
	color: #72738e !important;
	font-family: "lato", sans-serif;
}

.pan-log-tabs-tc a {
	color: #000000 !important;
	font-weight: 600;
	font-size: 16px;
	font-family: "lato", sans-serif;
	line-height: 21px;
}

.pan-log-tabs-tc li {
	text-align: center;
	margin-right: 8px;
}

.pan-log-tabs-tc .nav-tabs .nav-link {
	border: unset;
}

.pan-log-tabs-tc .nav-tabs {
	border-bottom: 1px solid #d9d9d9;
	padding-left: 20px;
}

.pan-log-tabs-tc .nav-link {
	display: block;
	padding: 17px 24px;
	margin-left: 11px;
	margin-right: 11px;
	position: relative;
}

.pan-log-tabs-tc .nav-tabs .nav-link.active {
	position: relative;
}
#modal-config .modal-body {
	padding: 0rem;
}

.dropdown-class .dropdown .btn-secondary {
	background: transparent;
	border: transparent;
	margin: 0;
	padding: 0;
	top: 0;
	flex: 0;
}

.dropdown-class .dropdown .btn {
	padding: 0;
}

.dropdown-class .dropdown .btn-secondary:not(:disabled):not(.disabled):active {
	box-shadow: none;
	border: none;
	background: #fff;
}

.dropdown-class .dropdown-menu {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 13px;
	color: #3a3c40;
	padding: 0;
	width: 190px;
	box-shadow: 0px 8px 15px 0px #00000066;
}

.dropdown-class .dropdown-item {
	padding: 5px 15px;
}

.dropdown-class .dropdown-item:active {
	background-color: #e9ecef;
	color: #3a3c40;
}

.dropdown-class .dropdown-item {
	display: block;
	width: 100%;
	clear: both;
	font-weight: 500;
	color: #3a3c40;
	font-family: "Lato", sans-serif;
	font-size: 13px;
	text-align: inherit;
	white-space: nowrap;
	background-color: transparent;
	border: 0;
}
.cj-test-section-tabs .tab-pane {
	height: calc(100vh - 200px);
	overflow-x: hidden;
	overflow-y: auto;
}

.cj-test-section-tabs .nav-tabs {
	background: #faf9f9;
	border: 1px solid #e7e7e7;
	border-radius: 10px;
	width: 100%;
}

.cj-test-section-tabs .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
	color: white;
	background: #72738e;
	border-radius: 10px;
	font-weight: 600;
	font-size: 14px;
	text-align: center;
	padding: 7px 79px;
	position: relative;
}

.cj-test-section-tabs .nav-tabs .nav-link {
	font-weight: var(--weight-LM);
	font-size: var(--size-14);
	padding: 7px 73px;
	position: relative;
	min-width: 150px;

	color: var(--btn-border);
	margin-bottom: none;
	border: none;
	border-top-left-radius: none;
	border-top-right-radius: none;
	text-align: center;
}
.prev-btn {
	position: absolute;
	bottom: 10px;
	left: 9px;
}
.testconfig-topDiv-name > .inputField {
	border: 0.7px solid var(--input-border);
	border-radius: 3px !important;
	font-size: 14px;
	background: var(--bg-inputfield);
	color: #6d6d6d;
	box-sizing: border-box;
	padding: 0.5rem 0.75rem;
	padding-right: 2rem;
	height: calc(1.5em + 0.75rem + 2px);
}
.add-btn-tc .btn-secondary {
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 6px 25px 6px 25px;
	gap: 10px;

	background: #72738e;
	border-radius: 40px;
}
.add-btn-tc .btn-secondary:hover {
	color: var(--bg-white);
	background-color: #72738e;
	box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
		2px 3px 7px 0px rgba(32, 99, 155, 0.2),
		7px 10px 12px 0px rgba(32, 99, 155, 0.17),
		44px 63px 22px 0px rgba(32, 99, 155, 0);
}
.add-btn-tc .btn-secondary:not(:disabled):not(.disabled):active,
.add-btn-tc .btn-secondary:not(:disabled):not(.disabled).active,
.add-btn-tc .show > .btn-secondary.dropdown-toggle {
	color: #fff;
	background-color: #72738e;
	border-color: #72738e;
}
.add-btn-tc-txt {
	font-family: "Montserrat", sans-serif, sans-serif;
	font-weight: 600;
	font-size: 13px;
	/* identical to box height */
	display: flex;
	align-items: center;

	color: #ffffff;
}
.fdf-add-container-tc
	.custom-radio.b-custom-control-sm
	.custom-control-label::after {
	position: absolute;
	top: 0.9px;
	left: -22px;
	display: block;
	width: 16px;
	height: 20px;
	content: "";
	background: 49% / 55% 65% no-repeat;
}

.fdf-add-container-tc
	.custom-radio
	.custom-control-input:checked
	~ .custom-control-label::after {
	background-image: url("../../assets/projects-icons/radio-btn.svg");
}

.fdf-add-container-tc
	.custom-control-input:checked
	~ .custom-control-label::before {
	color: #72738e;
	border-color: #72738e;
	background-color: #fff;
}

#startdatetimeconfig {
	width: 100%;
}

.time-div-tc-dpd
	.btns-stckd
	.btn-secondary:not(:disabled):not(.disabled):active,
.time-div-tc-dpd
	.btns-stckd
	.btn-secondary:not(:disabled):not(.disabled).active,
.time-div-tc-dpd .btns-stckd .show > .btn-secondary.dropdown-toggle {
	color: #3a3c40 !important;
	border-color: #c8d9e5 !important;
	background-color: #c8d9e5 !important;
	font-size: 14px;
	font-weight: 500;
}
.error-dp-tc .mx-input {
	border: 1px solid red !important;
	border-radius: 5px;
}

.tc-form-labels {
	font-family: "Montserrat";
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
}

.tc-form-fields .form-control {
	border: 1px solid #d0d5dd;
	padding: 10px 14px 10px 14px;
	/* width: 300px; */
	height: 37px;
	border-radius: 8px;
}

.tc-form-fields .mx-icon-calendar {
	display: none;
}

.tc-btnsDiv {
	height: 66px;
	border-radius: 0px 0px 12px 0px;
	border-top: 1px solid #d7d7d7;
}

.editor-field-tc {
	width: 960px;
	height: 143px;
	background: #ffffff;
	border: 1px solid #d0d5dd;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
}

.calender-image-tc {
	position: absolute;
	top: 38px;
	right: 10px;
}

.qb-add-drop-tc {
	background: #fdfdfd;
	color: #545454;
	text-align: left;
	border: none;
}

.time-div-tc {
	border: 1px solid #d0d5dd;
	padding: 6px 11px 10px 10px;
	width: 300px;
	height: 37px;
	border-radius: 8px;
}

.time-div-tc-dpd .btn-secondary {
	background-color: #f9f9f9;
	font-family: "lato", sans-serif;
	font-size: 14px;
	font-weight: 500;
	color: #3a3c40;
	padding: 5px 10px;
	border: none;
	text-align: left;
}

.priority-labels {
	font-family: "Montserrat";
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	color: #344054;
}
.configcontent-tabs-content {
	height: calc(100vh - 296px);
	overflow-x: hidden;
	overflow-y: auto;
}

.configcontent-tabs-content
	.custom-checkbox
	.custom-control-input:disabled:checked
	~ .custom-control-label::before {
	top: 3px;
	background-color: #adaaaa;
}

.configcontent-tabs-content
	.custom-radio
	.custom-control-input:disabled:checked
	~ .custom-control-label::before {
	background-color: #adaaaa;
}

.cancelpan-btn .btn-secondary {
	background-color: #fff;

	border: 1px solid #72738e;
	color: #72738e;
	border-radius: 40px;
	font-size: 11px;
	padding: 6px 25px 6px 25px;
	font-weight: 600;
	font-family: "Montserrat", sans-serif;
}

.cancelpan-btn .btn-secondary:disabled {
	color: #72738e;
	border: 1px solid #72738e !important;
	background-color: #fff;
	border-color: #72738e;
}

.cancelpan-btn .btn-secondary:hover {
	color: #72738e;
	border: 1px solid #72738e !important;
	background-color: #fff;
	border-color: #72738e;
	box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
		2px 3px 7px 0px rgba(32, 99, 155, 0.2),
		7px 10px 12px 0px rgba(32, 99, 155, 0.17),
		44px 63px 22px 0px rgba(32, 99, 155, 0);
}

.cancelpan-btn .btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
	color: #fff;
	border-color: #72738e;
	background-color: #72738e;
}

.dos-donts-fields .form-control {
	background: #ffffff;
	border: 1px solid #d0d5dd;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
}

.dos-donts-fields .form-control:disabled {
	background: #d0d5dd !important;
	border: 1px solid #d0d5dd;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
}

.dos-donts-fields .form-control::placeholder {
	font-family: "Montserrat";
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	color: #667085;
	width: 100%;
}
.w-96 {
	width: 96%;
}
.tc-tab-sel {
	position: absolute;
	border-bottom: 4px solid #72738e;
	box-shadow: 0px 4px 8px 0px #0000002b;
	width: 100%;
	height: 4px;
	border-radius: 25px 25px 6px 6px;
	top: 51px;
	left: 0px;
}
.error-txt-tc {
	font-family: "Montserrat";
	font-style: normal;
	font-weight: 500;
	font-size: 10px;
	color: #eb0002;
}
.grp-modal-foot {
	border-top: 1px solid #d7d7d7;
	padding: 15px 20px;
}
.conf-form-head {
	border-bottom: 1px solid #e4e7ec;
}
.conf-quill .ql-editor {
	height: 143px;
}
.conf-quill .quill-editor {
	padding: 10px 14px;
	height: 143px;
	background: #ffffff;
	border: 1px solid #d0d5dd;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
}
.conf-quill .ql-container {
	border: none;
}
.conf-quill .ql-toolbar {
	height: 41px;
	background: rgba(114, 115, 142, 0.1);
	border-radius: 8px;
	border: none;
}
.config-select .single-select .dropdown .btn-secondary {
	height: 37px;
}
.project-radio .custom-control-label::before {
	border: 0.125rem solid #72738e;
	background-color: transparent;
}

.project-radio
	.custom-radio
	.custom-control-input:checked
	~ .custom-control-label::after {
	background-image: none;
	border: 0.125rem solid #72738e;
	border-radius: 50%;
}

.project-radio .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-color: #e9f0f5 !important;
	border-width: 0.25rem;
	background-color: #72738e !important;
}

.project-radio .custom-control-label {
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-14);
	font-weight: var(--weight-LM);
	/* line-height: 1.5rem; */
	color: #3a3c40;
}

.project-radio .custom-control {
	margin-right: 10px;
}

.pff-checkbox .custom-checkbox .custom-control-label::before {
	border-radius: 3px;
}
.pff-checkbox .custom-control-label {
	line-height: 24px;
}
.dos-donts-head-tc {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #344054;
}
.fw-400 {
	font-weight: 400;
}
.dos-donts-num {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 20px;
	color: #72738e;
}
.jd-validicon-tc {
	position: absolute;
	left: 26px;
	top: 31px;
}
.video-enable-box {
	padding: 8px 12px;
	background: #d9d9d9;
	border-radius: 8px;
}
.video-enable-box .bs-popover-bottom > .arrow::after,
.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
	border-bottom-color: #d9d9d9;
}
.video-enable-box .popover-body {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 10px;
	text-align: center;
	padding: none;
	color: #696969;
}
</style>
